import { lazy, type ReactNode } from "react";
import { InjectRouteParams } from "../../Common/Routing/InjectRouteParams";
import { PermissionRoute } from "../../Common/Routing/PermissionRoute";

const Stocktakes = lazy(() => import("./Stocktakes"));
const StocktakeView = lazy(() => import("./View/StocktakeView"));
const ExpressStocktake = lazy(() => import("./Express/ExpressStocktake"));
const AdvancedStocktake = lazy(() => import("./Advanced/AdvancedStocktake"));
const StocktakeFinalise = lazy(() => import("./Finalise/StocktakeFinalise"));
const AdvancedStocktakePotentialVariance = lazy(() => import("./Advanced/AdvancedStocktakePotentialVariance"));

export default function StocktakesIndex(): Array<ReactNode> {
    return [
        <PermissionRoute
            title="Express Stocktake | Shopfront"
            permissions={[ "perform_stocktake" ]}
            path="/stocktake/express"
            key="stocktake-express"
            element={<ExpressStocktake />}
        />,
        <PermissionRoute
            title="Stocktakes | Shopfront"
            permissions={[ "see_stocktake" ]}
            path="/stocktake"
            key="stocktakes"
            element={<Stocktakes />}
        />,
        <PermissionRoute
            title="Advanced Stocktake | Shopfront"
            permissions={[ "perform_stocktake" ]}
            path="/stocktake/:id/edit"
            key="stocktake-advanced"
            element={<InjectRouteParams route={AdvancedStocktake} />}
        />,
        <PermissionRoute
            title="Finalise Stocktake | Shopfronts"
            permissions={[ "perform_stocktake" ]}
            path="/stocktake/:id/finalise"
            key="stocktake-finalise"
            element={<StocktakeFinalise />}
        />,
        <PermissionRoute
            title="View Stocktake | Shopfront"
            permissions={[ "see_stocktake" ]}
            path="/stocktake/:id"
            key="stocktake-view"
            element={<InjectRouteParams route={StocktakeView} />}
        />,
        <PermissionRoute
            title="Potential Variances | Shopfront"
            permissions={[ "see_stocktake" ]}
            path="/stocktake/:id/variance"
            key="stocktake-potential-variance"
            element={<InjectRouteParams route={AdvancedStocktakePotentialVariance} />}
        />,
    ];
}
